module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0"
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('h2', {
    staticClass: "pt-2 mx-2 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("XÁC THỰC TRA CỨU THÔNG TIN HỒ SƠ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "d-inline-block mt-4",
    staticStyle: {
      "width": "100%",
      "max-width": "700px"
    }
  }, [_c('v-flex', {
    staticClass: "px-2 pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3",
    staticStyle: {
      "max-width": "700px",
      "margin": "0 auto",
      "border": "1px solid #dddddd"
    },
    attrs: {
      "color": "#002c46b3",
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "form",
    staticClass: "mt-2",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Mã tra cứu",
      "prepend-inner-icon": "vpn_key",
      "height": "42",
      "rules": [function (v) { return !!v || 'Mã tra cứu là bắt buộc'; }],
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitPass($event)
      }
    },
    model: {
      value: (_vm.secretKey),
      callback: function($$v) {
        _vm.secretKey = $$v
      },
      expression: "secretKey"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-left",
    attrs: {
      "wrap": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "flex white--text",
    staticStyle: {
      "width": "calc(100% - 30px)"
    }
  }, [_vm._v("Mã tra cứu là dãy số gồm 4 ký tự được in trên giấy tiếp nhận hồ sơ và hẹn trả kết quả, mail thông báo tiếp nhận hồ sơ.")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left text-xs-center mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0 mr-1 my-0 white--text",
    attrs: {
      "color": "#0b72ba",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.submitPass
    }
  }, [_c('v-icon', [_vm._v("search")]), _vm._v(" \n                  Tra cứu\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 my-0 white--text",
    attrs: {
      "color": "#0b72ba",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', [_vm._v("reply")]), _vm._v(" \n                  Quay lại\n                ")], 1)], 1)], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogError),
      callback: function($$v) {
        _vm.dialogError = $$v
      },
      expression: "dialogError"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Bạn không có quyền truy cập hồ sơ \n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogError = false
      }
    }
  }, [_vm._v("Đồng ý")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c4c516a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c4c516a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckPasswordHP.vue
// module id = 520
// module chunks = 1